export default [
  {
    hideArrow: true,
    target: 'header .v-toolbar__content',
    title: 'OKASHOPをご利用いただきありがとうございます！',
    content: `<p>この画面では商品の検索をおこなうことができます。</p>
<p>ご利用方法をご覧になる場合は、「次へ」ボタンをクリックしてください。</p>`,
  },
  {
    target: '#tour-01001-step1',
    placement: 'right',
    title: 'キーワードで商品を絞り込む',
    content: `<p>キーワードを入力することで商品を絞り込むことができます。</p>`,
  },
  {
    target: '#tour-01001-step2',
    placement: 'right',
    title: '分類で商品を絞り込む',
    content: `<p>商品の分類を選んで商品を絞り込むこともできます。</p>`,
  },
  {
    target: '#tour-01001-step3',
    placement: 'top',
    title: '検索結果を表示',
    content: `<p>絞り込まれた商品はこちらに一覧で表示されます。</p>`,
  },
  {
    target: '#tour-01001-step4',
    placement: 'right',
    title: '在庫状況を確認する',
    content: `<p>商品画像をクリックして、商品の在庫状況を確認しましょう。</p>`,
  },
]
